/* eslint-disable i18next/no-literal-string */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isLoggedIn, login } from '../utils/AuthService';
import '../index.css';
import { Trans, withTranslation } from 'react-i18next';
import DeviceBetaRhbModeConfig from './DeviceBetaRhbModeConfig';
import { Button, Container } from '@material-ui/core';

const api = require('../utils/yoto-api');

const RHB_CONFIG_DEFAULT = {

    'modes': {
        'day': {
            'content': [

            ]
        },
        'night': {
            'content': [

            ]
        }
    }
};

class DeviceBetaRhbConfig extends Component {

    constructor() {

        super();

        this.state = { deviceConfig: null, updatedConfig: { config: {} },
            message: null,  restartRequired: false,
            openDialog: null, loadingLibrary: false
        };
    }

    async onModeConfigChange(mode, config) {
        const { rhbConfig } = this.state;
        rhbConfig.modes[mode] = config;
        this.setState({ rhbConfig });
        await this.save();
    }

    async save() {
        const { rhbConfig } = this.state;
        try {
            const apiResponse = await api.updateDeviceShortcuts(this.props.params.deviceId, { shortcuts: rhbConfig });
            console.log(apiResponse);
            this.setState({ message: ['', 'Settings updated'] });
            this.savedMessageTimeout = setTimeout(()=> {
                this.setState({ message: null });
            }, 1500);
        } catch (e) {
            this.setState({ message: ['ERROR', 'Error saving settings'] });
            this.savedMessageTimeout = setTimeout(()=> {
                this.setState({ message: null });
            }, 3000);
        }
    }

    async getShortcuts() {
        let rhbConfig;
        try {
            rhbConfig = await api.getDeviceShortcuts(this.props.params.deviceId);
        } catch (e) {
            rhbConfig = RHB_CONFIG_DEFAULT;
        }
        this.setState({ rhbConfig });
    }

    async resetShortcuts() {
        await api.updateDeviceShortcuts(this.props.params.deviceId, { shortcuts: null });
        await this.getShortcuts();
    }

    async componentDidMount() {
      
        if (!isLoggedIn()) {
            login(this.props.location.pathname);
        }
        await this.loadFamilyLibrary();
        await this.getShortcuts();

    }

    async loadFamilyLibrary() {

        this.setState({ loadingLibrary: true });
        this.setState({ loadingMessage: <Trans i18nKey='beta_settings_loading'>Loading Player Beta Settings...</Trans> });
        if (!isLoggedIn()) return;
        try {
            const library = await api.getFamilyLibrary();
            const hydratedFilteredSortedLibrary = await this.filterLibrary(library);
            this.setState({
                library: hydratedFilteredSortedLibrary,
            });
        } catch (err) {
            this.setState({ loadingMessage: <Trans i18nKey='beta_settings_loading_error'>Sorry, we are unable to load Beta settings for this Yoto Player, please tap the back button and try again</Trans> });
        } finally {
            this.setState({ loadingLibrary: false, loadingMessage: null });
        }

    }

    async filterLibrary(library) {
        // Hydrate all cards in parallel to ensure chapter/track info is present, using cache
        await Promise.all(
            library.map(libCard => this.hydrateCard(libCard.card))
        );
        const hydrated = [];
        for (const libCard of library) {
            const card = libCard.card;
            if (!card || !card.content || !Array.isArray(card.content.chapters)) continue;
            if (card.content.chapters.length !== 1) continue;
            const chapter = card.content.chapters[0];
            if (!chapter.tracks || chapter.tracks.length !== 1) continue;
            hydrated.push(libCard);
        }

        // sort the hydrated library by title lowercase
        hydrated.sort((a, b) => {
            const aTitle = a.card.title.toLowerCase();
            const bTitle = b.card.title.toLowerCase();
            if (aTitle < bTitle) return -1;
            if (aTitle > bTitle) return 1;
            return 0;
        });
        return hydrated;
    }

    async hydrateCard(card) {
        if (!card) return null;

        // prevent inflight requests  // FILIP: this block was causing the night mode card list to be empty, at least for my huge library, now avoiding hydrating twice but this might still cause trouble
        const cached = DeviceBetaRhbConfig.hydratedCardCache[card.cardId];
        if (cached === true) {
            return;
        }
        DeviceBetaRhbConfig.hydratedCardCache[card.cardId] = true;

        if (cached) {
            // Use cached hydrated card
            Object.assign(card, cached);
            if (card.cardId === '9ZnAK') console.log(`hydrating cached card ${card.cardId}`);

            return card;
        } else {
            if (card.cardId === '9ZnAK') console.log(`hydrating card  ${card.cardId}`);
        }
        if (card.content && card.content.chapters) {
            // Cache hydrated card
            DeviceBetaRhbConfig.hydratedCardCache[card.cardId] = JSON.parse(JSON.stringify(card));
            return card;
        }
        if (!card.content) card.content = {};
        try {
            card.content.chapters = (await api.getCardDetails(card.cardId)).content.chapters;
        } catch (error) {
            console.error(`Error hydrating card ${card.cardId}:`, error);
            // If there's an error, set cache to undefined to prevent blocking future requests
            delete DeviceBetaRhbConfig.hydratedCardCache[card.cardId];
        }
        // Cache hydrated card
        DeviceBetaRhbConfig.hydratedCardCache[card.cardId] = JSON.parse(JSON.stringify(card));
        return card;
    }


    render() {

        const { library, loadingMessage, rhbConfig } = this.state;
        return (
            <div>
                <div>{this.state.message ?
                    <div className='message' style={{ backgroundColor: this.state.message[0] === 'ERROR' ? '#cc0000' : '#E7F3B9E5' }}>
                        { this.state.message[1] ? <div style={{ fontSize: '0.7em', color: this.state.message[0] === 'ERROR' ? '#ffffff' : '#003C1F', opacity:'1' }}>{this.state.message[1]}</div> : '' }
                    </div> : ''}
                </div>
                {!rhbConfig || !library || loadingMessage ?
                    <div style={{ width: '100%', textAlign: 'center', padding: '2em' }}>{loadingMessage}</div> :
                    <Container>
                        <h1 style={{ fontSize: '24px' }}>Right button shortcuts</h1>
                        <p>Customise what the right hand button plays on your Player! Reorder what&#39;s there, or even add in your own favourite tracks!</p>
                        <DeviceBetaRhbModeConfig config={rhbConfig.modes['day']} mode="day" library={library} onChange={(config)=>this.onModeConfigChange('day', config)} />
                        <DeviceBetaRhbModeConfig config={rhbConfig.modes['night']} mode="night" library={library} onChange={(config)=>this.onModeConfigChange('night', config)} />
                        <div style={{ padding: '20px', textAlign: 'right' }}>
                            <Button onClick={() => this.resetShortcuts()} color="primary">Reset to Defaults</Button>
                        </div>
                    </Container>
                }
            </div>
        );
    }
}

DeviceBetaRhbConfig.propTypes = {
    location: PropTypes.object,
    params: PropTypes.object
};

DeviceBetaRhbConfig.hydratedCardCache = {};

export default  withTranslation()(DeviceBetaRhbConfig);
